import { ComponentProps } from 'react';
import Divider from 'antd/es/divider';

import './OpDivider.scss';

/**
 * OpDivider is a wrapper around Ant Design's Divider component.
 * It provides a visual separator between content sections with optional text labels.
 * 
 * Use this component to create clear visual boundaries between different sections of content,
 * either horizontally or vertically.
 * 
 * @example
 * <OpDivider />
 * <OpDivider orientation="left">Section Title</OpDivider>
 * 
 */
export const OpDivider = ({
  children,
  className = '',
  ...dividerProps
}: ComponentProps<typeof Divider>) => (
  <Divider className={`op-divider ${className}`.trim()} {...dividerProps}>
    {children}
  </Divider>
);
